import { default as _91_46_46_46cms_93SWZ0roZtvdMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93z9NoauKyD9Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/3d-projects/[...slug].vue?macro=true";
import { default as index5tVqF0vQrNMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93Eu4UfduRY4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/akcii/[...slug].vue?macro=true";
import { default as index4ySc2Il4LVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_933nlgVEGg8MMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/articles/[...slug].vue?macro=true";
import { default as indexNqJs8hfSu7Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/articles/index.vue?macro=true";
import { default as indexBysxfbPAfwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/authorization/index.vue?macro=true";
import { default as indexkNLP129Xm8Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93BM9X5VaS1JMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93edYri2gXA2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalog/[...slug].vue?macro=true";
import { default as indexN3YJBZLgSzMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93HuBz6smFXRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultV4aDjI76sjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalogsearch/result.vue?macro=true";
import { default as indexmqQ9W4bKlBMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93zYSU9Q8QotMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93gUWDYkYPWcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/fabriki/[...slug].vue?macro=true";
import { default as indexXiuM4VcMiVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/fabriki/index.vue?macro=true";
import { default as _91hash_937tup1nJetXMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93ekQpYPSrOGMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/product/[...slug].vue?macro=true";
import { default as indexUaOmvVvGhIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/profile/index.vue?macro=true";
import { default as indextIIpdOMHWLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/profile/orders/index.vue?macro=true";
import { default as index9rGXbSlPHzMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93BYEPT6aCOxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/sets/[...slug].vue?macro=true";
import { default as indexYEtLWgszLZMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93SWZ0roZtvdMeta?.name ?? "cms",
    path: _91_46_46_46cms_93SWZ0roZtvdMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93SWZ0roZtvdMeta || {},
    alias: _91_46_46_46cms_93SWZ0roZtvdMeta?.alias || [],
    redirect: _91_46_46_46cms_93SWZ0roZtvdMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93z9NoauKyD9Meta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93z9NoauKyD9Meta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93z9NoauKyD9Meta || {},
    alias: _91_46_46_46slug_93z9NoauKyD9Meta?.alias || [],
    redirect: _91_46_46_46slug_93z9NoauKyD9Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index5tVqF0vQrNMeta?.name ?? "3d-projects",
    path: index5tVqF0vQrNMeta?.path ?? "/3d-projects",
    meta: index5tVqF0vQrNMeta || {},
    alias: index5tVqF0vQrNMeta?.alias || [],
    redirect: index5tVqF0vQrNMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Eu4UfduRY4Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93Eu4UfduRY4Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93Eu4UfduRY4Meta || {},
    alias: _91_46_46_46slug_93Eu4UfduRY4Meta?.alias || [],
    redirect: _91_46_46_46slug_93Eu4UfduRY4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index4ySc2Il4LVMeta?.name ?? "akcii",
    path: index4ySc2Il4LVMeta?.path ?? "/akcii",
    meta: index4ySc2Il4LVMeta || {},
    alias: index4ySc2Il4LVMeta?.alias || [],
    redirect: index4ySc2Il4LVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933nlgVEGg8MMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_933nlgVEGg8MMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_933nlgVEGg8MMeta || {},
    alias: _91_46_46_46slug_933nlgVEGg8MMeta?.alias || [],
    redirect: _91_46_46_46slug_933nlgVEGg8MMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNqJs8hfSu7Meta?.name ?? "articles",
    path: indexNqJs8hfSu7Meta?.path ?? "/articles",
    meta: indexNqJs8hfSu7Meta || {},
    alias: indexNqJs8hfSu7Meta?.alias || [],
    redirect: indexNqJs8hfSu7Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexBysxfbPAfwMeta?.name ?? "authorization",
    path: indexBysxfbPAfwMeta?.path ?? "/authorization",
    meta: indexBysxfbPAfwMeta || {},
    alias: indexBysxfbPAfwMeta?.alias || [],
    redirect: indexBysxfbPAfwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexkNLP129Xm8Meta?.name ?? "cart",
    path: indexkNLP129Xm8Meta?.path ?? "/cart",
    meta: indexkNLP129Xm8Meta || {},
    alias: indexkNLP129Xm8Meta?.alias || [],
    redirect: indexkNLP129Xm8Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93BM9X5VaS1JMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93BM9X5VaS1JMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93BM9X5VaS1JMeta || {},
    alias: _91_46_46_46id_93BM9X5VaS1JMeta?.alias || [],
    redirect: _91_46_46_46id_93BM9X5VaS1JMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93edYri2gXA2Meta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93edYri2gXA2Meta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93edYri2gXA2Meta || {},
    alias: _91_46_46_46slug_93edYri2gXA2Meta?.alias || [],
    redirect: _91_46_46_46slug_93edYri2gXA2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexN3YJBZLgSzMeta?.name ?? "catalog",
    path: indexN3YJBZLgSzMeta?.path ?? "/catalog",
    meta: indexN3YJBZLgSzMeta || {},
    alias: indexN3YJBZLgSzMeta?.alias || [],
    redirect: indexN3YJBZLgSzMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HuBz6smFXRMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93HuBz6smFXRMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93HuBz6smFXRMeta || {},
    alias: _91_46_46_46slug_93HuBz6smFXRMeta?.alias || [],
    redirect: _91_46_46_46slug_93HuBz6smFXRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultV4aDjI76sjMeta?.name ?? "catalogsearch-result",
    path: resultV4aDjI76sjMeta?.path ?? "/catalogsearch/result",
    meta: resultV4aDjI76sjMeta || {},
    alias: resultV4aDjI76sjMeta?.alias || [],
    redirect: resultV4aDjI76sjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexmqQ9W4bKlBMeta?.name ?? "clear-page-slider",
    path: indexmqQ9W4bKlBMeta?.path ?? "/clear-page-slider",
    meta: indexmqQ9W4bKlBMeta || {},
    alias: indexmqQ9W4bKlBMeta?.alias || [],
    redirect: indexmqQ9W4bKlBMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93zYSU9Q8QotMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93zYSU9Q8QotMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93zYSU9Q8QotMeta || {},
    alias: _91_46_46_46slug_93zYSU9Q8QotMeta?.alias || [],
    redirect: _91_46_46_46slug_93zYSU9Q8QotMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93gUWDYkYPWcMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93gUWDYkYPWcMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93gUWDYkYPWcMeta || {},
    alias: _91_46_46_46slug_93gUWDYkYPWcMeta?.alias || [],
    redirect: _91_46_46_46slug_93gUWDYkYPWcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexXiuM4VcMiVMeta?.name ?? "fabriki",
    path: indexXiuM4VcMiVMeta?.path ?? "/fabriki",
    meta: indexXiuM4VcMiVMeta || {},
    alias: indexXiuM4VcMiVMeta?.alias || [],
    redirect: indexXiuM4VcMiVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_937tup1nJetXMeta?.name ?? "order-status-hash",
    path: _91hash_937tup1nJetXMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_937tup1nJetXMeta || {},
    alias: _91hash_937tup1nJetXMeta?.alias || [],
    redirect: _91hash_937tup1nJetXMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93ekQpYPSrOGMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93ekQpYPSrOGMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93ekQpYPSrOGMeta || {},
    alias: _91_46_46_46slug_93ekQpYPSrOGMeta?.alias || [],
    redirect: _91_46_46_46slug_93ekQpYPSrOGMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexUaOmvVvGhIMeta?.name ?? "profile",
    path: indexUaOmvVvGhIMeta?.path ?? "/profile",
    meta: indexUaOmvVvGhIMeta || {},
    alias: indexUaOmvVvGhIMeta?.alias || [],
    redirect: indexUaOmvVvGhIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indextIIpdOMHWLMeta?.name ?? "profile-orders",
    path: indextIIpdOMHWLMeta?.path ?? "/profile/orders",
    meta: indextIIpdOMHWLMeta || {},
    alias: indextIIpdOMHWLMeta?.alias || [],
    redirect: indextIIpdOMHWLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: index9rGXbSlPHzMeta?.name ?? "recently",
    path: index9rGXbSlPHzMeta?.path ?? "/recently",
    meta: index9rGXbSlPHzMeta || {},
    alias: index9rGXbSlPHzMeta?.alias || [],
    redirect: index9rGXbSlPHzMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93BYEPT6aCOxMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93BYEPT6aCOxMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93BYEPT6aCOxMeta || {},
    alias: _91_46_46_46slug_93BYEPT6aCOxMeta?.alias || [],
    redirect: _91_46_46_46slug_93BYEPT6aCOxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexYEtLWgszLZMeta?.name ?? "wishlist",
    path: indexYEtLWgszLZMeta?.path ?? "/wishlist",
    meta: indexYEtLWgszLZMeta || {},
    alias: indexYEtLWgszLZMeta?.alias || [],
    redirect: indexYEtLWgszLZMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/pages/wishlist/index.vue").then(m => m.default || m)
  }
]